var getIP = function () {
    var origin = window.location.origin;
    if (origin.startsWith("http://localhost")) {
        //REPLACE the hostname below to change which server GUI makes API calls to....
        // return "https://cpaas.comviva.com";
        // return "https://ngage-gui-app-ingress-dev1-1780850552.ap-south-1.elb.amazonaws.com";
        // return "https://venus.ngagecpaas.com";
        //  return "https://pvg.ngagecpaas.com";
        return "https://dev1.ngagecpaas.com";
        // return "https://dev3.ngagecpaas.com";
        // return "https://dev4.ngagecpaas.com";
        // return "https://qa4.ngagecpaas.com";
        // return "https://autocpaas.comviva.com";
        //return "https://omocpaas.comviva.com";
        // return "http://emailcpaas.comviva.com:32606";
    }
    else {
        return origin;
    }
};
export default getIP;
